import { Text } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

import { Switch } from './switch/Switch';

interface Props {
  color_type: 'blue400' | 'purple400';
  label: string;
  checked: boolean;
  handleClick: () => void;
}

export const ShippingFilter = ({ color_type, label, checked, handleClick }: Props) => {
  return (
    <FilterToggle>
      <ToggleArea onClick={handleClick} style={{ cursor: 'pointer' }}>
        <Switch checked={checked} />
        <Text variant='Body_14_SemiBold' color={color_type} style={{ margin: '0 0 0 6px' }}>
          {label}
        </Text>
      </ToggleArea>
    </FilterToggle>
  );
};

const FilterToggle = styled.div`
  margin: 0 0 10px 0;
  padding: 0 16px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
`;

const ToggleArea = styled.div`
  padding: 0 8px 0 0;
  display: flex;
  align-items: center;
  justify-content: end;
`;
